import { ChainConfig } from './types';

export const BNB_MAINNET: ChainConfig = {
  chainId: '0x38', // 56 in hex
  chainName: 'BNB Smart Chain Mainnet',
  nativeCurrency: {
    name: 'BNB',
    symbol: 'BNB',
    decimals: 18,
  },
  rpcUrls: [
    'https://bsc-dataseed1.binance.org',
    'https://bsc-dataseed2.binance.org',
    'https://bsc-dataseed3.binance.org',
    'https://bsc-dataseed4.binance.org',
  ],
  blockExplorerUrls: ['https://bscscan.com'],
};

export const BNB_TESTNET: ChainConfig = {
  chainId: '0x61', // 97 in hex
  chainName: 'BNB Smart Chain Testnet',
  nativeCurrency: {
    name: 'tBNB',
    symbol: 'tBNB',
    decimals: 18,
  },
  rpcUrls: [
    'https://data-seed-prebsc-1-s1.binance.org:8545',
    'https://data-seed-prebsc-2-s1.binance.org:8545',
    'https://data-seed-prebsc-1-s2.binance.org:8545',
  ],
  blockExplorerUrls: ['https://testnet.bscscan.com'],
};

export const SUPPORTED_CHAINS = {
  'bnb-mainnet': BNB_MAINNET,
  'bnb-testnet': BNB_TESTNET,
};

export function getChainById(chainId: string): ChainConfig | undefined {
  return Object.values(SUPPORTED_CHAINS).find(
    chain => chain.chainId === chainId || chain.chainId === `0x${parseInt(chainId, 10).toString(16)}`
  );
}

export function hexToDecimal(hex: string): number {
  return parseInt(hex, 16);
}

export function decimalToHex(decimal: number | string): string {
  return `0x${parseInt(decimal.toString(), 10).toString(16)}`;
}